import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

function SvgComponent(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={141} height={32} viewBox="0 0 141 32" fill="none" {...props}>
            <Path
                d="M45.6119 16.1702C45.6119 25.5745 54.261 32 64.7848 32C69.2158 32 73.2208 30.9362 75.6068 29.1915L76.7572 19.617C73.6469 22.4255 69.5993 24.0426 65.7647 24.0426C60.3537 24.0426 55.7948 20.9362 55.7948 15.9574C55.7948 11.0213 60.4815 7.95745 65.6795 7.95745C69.5141 7.95745 73.1356 9.53191 76.2033 12.2979L75.9476 2.59575C72.6669 0.765959 68.7046 0 65.1256 0C53.3236 0 45.6119 7.31915 45.6119 16.1702Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M126.855 32C121.87 32 116.587 30.3404 114.158 28L113.945 18.4681C116.757 21.9149 121.87 24.383 126.556 24.383C129.454 24.383 131.371 23.4894 131.371 22.0426C131.371 20.518 128.967 19.9105 125.859 19.1249C125.063 18.9237 124.221 18.7109 123.361 18.4681C117.396 16.8936 113.647 14 113.647 9.40426C113.647 3.82979 119.654 0 127.366 0C132.095 0 136.952 1.48936 139.381 3.06383L139.977 12C136.228 9.10638 131.627 7.53191 127.409 7.53191C124.767 7.53191 122.892 8.25532 122.892 9.48936C122.892 10.7949 124.614 11.2406 127.946 12.1028C128.741 12.3086 129.627 12.538 130.604 12.8085C136.825 14.3404 141 16.9787 141 21.9574C141 27.8723 134.694 32 126.855 32Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M101.556 31.4468L89.9668 18.4681V31.4468H80.636V0.553212H89.9668V12.5532L101.897 0.553212H113.741L98.5733 15.149L113.571 31.4468H101.556Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path d="M32.5829 31.4468V0.553212H42.0415V31.4468H32.5829Z" fill={ds.colorValue.icon.primary} />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0.553212V31.4468H9.33081V22.5532H14.9123C24.9674 22.5532 29.6115 17.4043 29.6115 11.4043C29.6115 5.78725 25.7343 0.553212 14.6566 0.553212H0ZM19.599 11.4894C19.599 14.0426 17.213 15.2766 14.0175 15.2766H9.33081V7.82981H14.0175C17.3834 7.82981 19.599 8.97875 19.599 11.4894Z"
                fill={ds.colorValue.icon.primary}
            />
        </Svg>
    );
}

export default SvgComponent;
